var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContractsAcs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6563_18442)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 14.8245V15.4051C39.9513 16.0027 39.7513 16.5796 39.3994 17.0556C39.0088 17.5839 36.4923 20.0312 35.918 20.6055C35.1175 21.4059 34.3762 22.1491 33.5731 22.948C33.3345 23.1854 33.2588 23.3434 33.0288 23.5758L30.678 25.9124C30.3731 26.2173 30.4636 26.3156 30.4681 26.8744L30.469 36.2502C30.4774 38.468 28.9335 40 27.1875 40H3.28125C1.64773 40 0 38.3473 0 36.7188V3.28125C0 1.65266 1.64773 0 3.28125 0H23.9062C25.4184 0 26.5554 1.4382 27.3633 2.24609C28.5766 3.45945 30.1684 4.70352 30.4395 6.20125C30.5259 6.67891 30.4688 15.3134 30.4688 16.0156C30.7584 15.8217 33.4941 12.9933 34.3198 12.2885C35.5948 11.2 37.647 11.2877 39.0043 12.6363C39.603 13.2311 39.9352 14.0233 40 14.8245ZM24.1406 27.4219C24.1594 27.1963 24.7774 25.2428 24.9426 25.0207C25.1048 24.8026 25.302 24.7022 25.4688 24.4531L27.0913 26.0338C26.6966 26.6517 26.3617 26.722 25.8108 26.9045C25.3927 27.043 24.5247 27.3899 24.1406 27.4219ZM28.7694 24.3944L27.1693 22.7525L32.7934 17.1684L34.3941 18.7309L28.7694 24.3944ZM21.0156 29.2969C21.0156 30.1152 21.4473 30.5469 22.2656 30.5469C22.5182 30.5469 26.6752 29.1928 27.4693 28.8755C27.7527 28.7623 27.8807 28.6448 28.125 28.5156C28.125 29.9005 28.2028 35.2941 28.123 36.4042C28.0645 37.2177 27.5959 37.6562 26.7188 37.6562H3.75C2.8293 37.6562 2.34375 37.1707 2.34375 36.25V3.75C2.34375 2.8293 2.8293 2.34375 3.75 2.34375H21.0938V8.35938C21.0938 8.83844 21.6303 9.375 22.1094 9.375H28.125V18.2812C28.125 18.7234 23.0939 22.9936 22.6655 24.1498C22.3898 24.894 21.0156 28.9834 21.0156 29.2969ZM36.0938 17.0312L34.5122 15.4878C34.8365 15.016 35.8876 13.9062 36.4844 13.9062C37.2347 13.9062 37.8618 14.7141 37.5483 15.5149C37.4293 15.8188 36.3606 16.8525 36.0938 17.0312ZM23.4375 2.34375C24.4278 2.36578 25.1849 3.42711 26.1133 4.35547C27.0416 5.28391 28.1029 6.04094 28.125 7.03125H23.4375V2.34375Z",
    fill: "#7663EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6875 12.7344C4.6875 13.4929 5.06797 14.0625 5.70313 14.0625H22.4219C23.7707 14.0625 23.7707 11.7188 22.4219 11.7188H5.70313C5.22406 11.7188 4.6875 12.2553 4.6875 12.7344Z",
    fill: "#7663EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6875 22.1094C4.6875 22.8679 5.06797 23.4375 5.70313 23.4375H17.7344C19.0832 23.4375 19.0832 21.0938 17.7344 21.0938H5.70313C5.22406 21.0938 4.6875 21.6303 4.6875 22.1094Z",
    fill: "#7663EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6875 26.7969C4.6875 27.5554 5.06797 28.125 5.70313 28.125H17.7344C19.0832 28.125 19.0832 25.7812 17.7344 25.7812H5.70313C5.22406 25.7812 4.6875 26.3178 4.6875 26.7969Z",
    fill: "#7663EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6875 17.4219C4.6875 18.1804 5.06797 18.75 5.70313 18.75H17.7344C19.0832 18.75 19.0832 16.4062 17.7344 16.4062H5.70313C5.22406 16.4062 4.6875 16.9428 4.6875 17.4219Z",
    fill: "#7663EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0625 33.9844C14.0625 34.7429 14.443 35.3125 15.0781 35.3125H22.4219C23.7707 35.3125 23.7707 32.9688 22.4219 32.9688H15.0781C14.5991 32.9688 14.0625 33.5053 14.0625 33.9844Z",
    fill: "#7663EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6563_18442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractsAcs);
export default __webpack_public_path__ + "static/media/contracts-acs.0645ec0bd5778773c5531847cf4dd362.svg";
export { ForwardRef as ReactComponent };